<script lang="ts" setup>
import { provideInBlockEditor } from '#layers/block-engine/utils/block/editor';

defineProps<{
	empty: boolean;
}>();

// We need to re-enable the block editor as we may put slot content inside another block
provideInBlockEditor(true);
</script>

<template>
	<slot />
</template>
